module.exports = __webpack_public_path__ + "img/listings.10aea4a.jpg";